"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var rotatorKeyframes = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(270deg);}"]);
var colorsKeyframes = (0, _styledComponents.keyframes)(["0%{stroke:#4285F4;}25%{stroke:#DE3E35;}50%{stroke:#F7C223;}75%{stroke:#1B9A59;}100%{stroke:#4285F4;}"]);
var dashKeyframes = (0, _styledComponents.keyframes)(["0%{stroke-dashoffset:187;}50%{stroke-dashoffset:46.75;transform:rotate(135deg);}100%{stroke-dashoffset:187;transform:rotate(450deg);}"]);

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Spinner___StyledWrapper",
  componentId: "sc-1rmwfwu-0"
})(["animation:", " 1.4s linear infinite;"], rotatorKeyframes);

var _StyledCircle = (0, _styledComponents["default"])("circle").withConfig({
  displayName: "Spinner___StyledCircle",
  componentId: "sc-1rmwfwu-1"
})(["stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:", " 1.4s ease-in-out infinite,", " 5.6s ease-in-out infinite;"], dashKeyframes, colorsKeyframes);

function Spinner(props) {
  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({
    component: 'svg',
    width: "65px",
    height: "65px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement(_StyledCircle, {
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  }));
}

var _default = Spinner;
exports["default"] = _default;